"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGatsbyQueryStore = exports.GatsbyQueryStore = void 0;
const react_1 = __importDefault(require("react"));
const GatsbyQueryContext = react_1.default.createContext(false);
const GatsbyQueryStore = ({ children, data }) => {
    const value = react_1.default.useMemo(() => ({
        data
    }), []);
    return (react_1.default.createElement(GatsbyQueryContext.Provider, { value: value }, children));
};
exports.GatsbyQueryStore = GatsbyQueryStore;
const useGatsbyQueryStore = () => {
    const ctx = react_1.default.useContext(GatsbyQueryContext);
    if (!ctx)
        throw new Error("Missing Gatsby Query Store");
    return ctx;
};
exports.useGatsbyQueryStore = useGatsbyQueryStore;
//# sourceMappingURL=gatsby-query-store.js.map